<template>
  <div id="app">
    <!-- 头部 -->
    <div>
      <div class="inside-head" v-if="$route.meta.showHead">
        <div class="inside-head-main">
          <div class="inside-head-main-left">
            <img :src="'icon_head1.png' | imagePath" class="inside-head-main-logo" />
            <div class="inside-head-main-name pointer"
              @click="$.router.push('exhibition')">
              {{$t('message.homePage')}}
              <!-- <h1>{{$t('message.loginTitle')}}</h1>
              <p>{{$t('message.loginDesc')}}</p> -->
            </div>
            <!-- <img :src="'icon_home.png' | imagePath" alt=""
              @click="$.router.push('/index',{exhibition_id:shengshi_exhibition_id})" class="toHome pointer"
              v-show="!$route.meta.showCurrentExhibition" /> -->
            <div style="display: flex;align-items: center;" v-show="exhibition_name != ''">
              <img v-if="shengshi_exhibition_id>0" :src="exhibition_logo" class="inside-head-main-current-logo" />
              <div v-if="shengshi_exhibition_id>0" style="background-color: #CF152D" class="inside-head-main-current-name pointer" @click="$.router.push('/index',{exhibition_id:shengshi_exhibition_id})">{{$t('message.currentExhibition')}}：{{exhibition_name}}</div>
              <!-- <button class="inside-head-main-change" @click="$.router.push('exhibition')"> -->
                <!-- 切换展会 -->
                <!-- {{$t('message.switchExhibition')}} -->
              <!-- </button> -->
            </div>
          </div>
          <div class="inside-head-main-right">
            <!-- <p class="pointer" @click="$.router.push('account')">{{userPhone}}</p> -->
            <p class="pointer" @click="$.router.push('account')" style="margin: 0 20px;">
              {{$t('message.me')}}
            </p>
            <button class="inside-head-main-loginout" @click="loginOut()">
              <!-- 退出登录 -->
              {{$t('message.logout')}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 中间部分 -->
    <div class="bodyCenter" style="position: relative;">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" v-wechat-title="title"></router-view>
        <!-- <transition> </transition> -->
      </keep-alive>
      <!-- <transition> </transition> -->
      <router-view v-if="!$route.meta.keepAlive" v-wechat-title="title"></router-view>
    </div>
    <!-- 底部 -->
    <div>
      <div class="footer" v-if="$route.meta.showHead">
        Copyright ©：2017 grandevents 沪ICP备 16000976号
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'App',
    data() {
      return {
        shengshi_exhibition_id: this.$.storage.getItem('shengshi_exhibition_id') ? this.$.storage.getItem(
          'shengshi_exhibition_id') : '',
        exhibition_name: '',
        exhibition_logo: '',
        userPhone: this.$.storage.getItem('userPhone'),
        language: this.$.storage.getItem('lang') || 'cn',
        basic: {},
        isLogin: false,
        avatar: '',
        nickname: '',
        company_name: '',
        baseUrl: '',
        systemTime: null,
        name: '',
        newsNum: 0,
        timer: false,
        screenWidth: document.body.clientWidth
      }
    },
    computed: {
      title() {
        if (this.language == 'en') {
          return this.$route.meta.titleEn;
        } else {
          return this.$route.meta.title;
        }
      }
    },
    watch: {
      '$i18n.locale'(n) {
        this.language = n;
      },
      $route: {
        handler: function(val, oldVal) {
          this.windowChange()
        },
        // 深度观察监听
        deep: true
      }

    },
    methods: {
      // 退出登录
      loginOut() {
        this.$.storage.clear()
        this.$.router.replace('login')
      },

      windowChange() {
        this.screenWidth = document.body.clientWidth - 132 - 257
        if (this.screenWidth < 831) {
          this.screenWidth = 831
        }
        setTimeout(() => {
          document.querySelector('.account-right,.body-left').setAttribute('style', 'width:' + this.screenWidth +
            'px');
        }, 50)
      }
    },

    mounted() {
      this.windowChange()
      const that = this
      window.onresize = () => {
          return (() => {
            that.windowChange()
          })()
        },
        // 监听展会变化
        this.$.notification.on('exhibition_name', res => {
          this.$.storage.setItem('exhibition_info', JSON.stringify(res))
          this.exhibition_name = JSON.parse(this.$.storage.getItem('exhibition_info')).name
          this.exhibition_logo = JSON.parse(this.$.storage.getItem('exhibition_info')).logo
          this.shengshi_exhibition_id = this.$.storage.getItem('shengshi_exhibition_id') ? this.$.storage.getItem(
            'shengshi_exhibition_id') : ''
        })
      this.exhibition_name = this.$.storage.getItem('exhibition_info') ? JSON.parse(this.$.storage.getItem(
        'exhibition_info')).name : ''
      this.exhibition_logo = this.$.storage.getItem('exhibition_info') ? JSON.parse(this.$.storage.getItem(
        'exhibition_info')).logo : ''


      // 监听登录状态
      this.$.notification.on('login', bo => {
        console.info(bo)
        this.isLogin = bo == 1;
        this.userPhone = this.$.storage.getItem('userPhone') ? this.$.storage.getItem('userPhone') : ''
        this.shengshi_exhibition_id = this.$.storage.getItem('shengshi_exhibition_id') ? this.$.storage.getItem(
          'shengshi_exhibition_id') : ''
        this.language = this.$.storage.getItem('lang') || 'cn'
      })
      //判断是否是ie浏览器
      function checkIE() {
        return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
      }
      // if (checkIE()) {
      //   window.addEventListener('hashchange', () => {
      //     var currentPath = window.location.hash.slice(1);
      //     if (this.$route.path !== currentPath) {
      //       this.$router.push(currentPath)
      //     }
      //   }, false)
      // }
    },
    beforeDestroy() {

    }
  }
</script>

<style>
  #app {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  /* 头部 */
  .inside-head {
    background-color: #282C31;
    height: 66px;
    width: 100%;
  }

  .inside-head-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  .bodyWrap {
    display: flex;
    justify-content: space-between;
  }

  @media screen and (max-width: 1300px) {
    .inside-head-main {
      width: 1200px;
      margin: auto;
    }

    .bodyWrap {
      width: 1200px;
      margin: 13px auto;
    }
  }

  @media screen and (min-width: 1300px) {
    .inside-head-main {
      margin: 0 66px;
    }

    .bodyWrap {
      margin: 13px 66px;
    }
  }

  .inside-head-main-left {
    display: flex;
    align-items: center;
  }

  .inside-head-main-logo {
    display: block;
    width: 34px;
    height: 42px;
    margin-right: 15px;
  }

  .inside-head-main-name {
    color: #FFFFFF;
    text-align: center;
    line-height: 20px;
    padding: 0 10px;
    background-color: #CF152D;
  }

  .toHome {
    width: 30px;
    height: 30px;
    margin-left: 30px;
  }

  .inside-head-main-name h1 {
    font-size: 20px;
  }

  .inside-head-main-name p {
    font-size: 12px;
  }

  .inside-head-main-current-logo {
    margin-left: 15px;
    margin-right: 15px;
    width: 21px;
    height: 21px;
  }

  .inside-head-main-current-name {
    background-color: rgba(86, 89, 94, 0.6);
    padding: 0 5px;
    color: #FFFFFF;
    border-radius: 2px;
    line-height: 20px;
  }

  .inside-head-main-change {
    background: #CF152D url(assets/images/icon_head3.png) no-repeat 7px center;
    background-size: 10px 10px;
    color: #FFFFFF;
    line-height: 20px;
    height: 20px;
    border-radius: 2px;
    padding-left: 20px;
    padding-right: 7px;
    font-size: 12px;
    margin-left: 7px;
  }

  .inside-head-main-right {
    display: flex;
    align-items: center;
    color: #FFFFFF;
  }

  .inside-head-main-right p {
    font-weight: 500;
    font-size: 12px;
    background-color: #CF152D;
    line-height: 20px;
    padding: 0 10px;
  }

  .inside-head-main-loginout {
    background: #CF152D url(assets/images/icon_head4.png) no-repeat 7px center;
    background-size: 10px 10px;
    color: #FFFFFF;
    line-height: 20px;
    height: 20px;
    border-radius: 2px;
    padding-left: 20px;
    padding-right: 7px;
    font-size: 12px;
    margin-left: 20px;
  }

  .footer {
    text-align: center;
    color: #FFFFFF;
    background-color: #282C31;
    font-size: 14px;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue